<template>
  <div class="text-editor">
    <quill-editor ref="text-editor" :content="content" :options="editorOption" @change="onEditorChange($event)" />
    <div v-if="enableCharsLimit" class="text-right mt-3">
      <p>{{ charCount > 500 ? '500' : charCount }}/500</p>
    </div>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
export default {
  name: 'TextEditor',
  components: { quillEditor },
  props: {
    editorOption: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: String,
      default: ''
    },
    enableCharsLimit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editorText: '',
      savedContent: ''
    };
  },
  computed: {
    charCount() {
      return this.editorText.trim().length;
    }
  },
  methods: {
    onEditorChange({ quill, html, text }) {
      if (this.enableCharsLimit) {
        if (text.trim().length <= 500) {
          this.editorText = text;
          this.savedContent = this.$refs['text-editor'].quill.getContents();
          this.$emit('update:content', html);
          this.$emit('editorChange', { quill, html, text });
        } else {
          this.editorText = text;
          this.$refs['text-editor'].quill.setContents(this.savedContent);
        }
      } else {
        this.$emit('update:content', html);
        this.$emit('editorChange', { quill, html, text });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/textEditor.scss';
</style>
